export default __webpack_public_path__ + "static/media/green.47328b8c.ogg";